import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const Google = ({featuredProjectsList}) => {
  const project = getProject('google');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <WorkHeader component={{ project }} />

        <VimeoVideo
          className="g-row"
          component={{
            video: '59177422',
            posterVideo: '215749442'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="milestones">Milestones</h2>
          <ul>
            <li>135% increase in AdWords clicks.</li>
            <li>131% increase in AdWords advertisers who posted an ad.</li>
            <li>617% increase in Apps business trials.</li>
          </ul>
        </AnimateIn>

        <AnimateIn className="text g-row">
          <h2 id="partners">Partners</h2>
          <p>BBH London</p>
        </AnimateIn>

        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Design',
                items: ['Illustration', 'UI/UX Design', 'Visual Design']
              },

              {
                title: 'Delivery',
                items: [
                  'A/B Testing',
                  'Analytics & Insights',
                  'Integration Support',
                  'Launch',
                  'Optimization'
                ]
              },

              {
                title: 'Content',
                items: ['Animation']
              }
            ]
          }}
        />
      </article>
    </Layout>
  );
};
export { hardcodedStaticProps as getStaticProps };

export default Google;
